import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { Modal } from '@/components/ui/Modal'
import api from '@/services/api'
import { referralsService } from '@/services/referralsService'
import { getFriendlyError } from '@/utils/getFriendlyError'

type IndicadorOption = { id: string; nome: string; empresa?: string | null }

export function IndicacaoClienteModal({ open, onClose, onSaved }: { open: boolean; onClose: () => void; onSaved: () => void }) {
  const [indicadores, setIndicadores] = useState<IndicadorOption[]>([])
  const [parceiroId, setParceiroId] = useState('')
  const [nome, setNome] = useState('')
  const [empresa, setEmpresa] = useState('')
  const [telefone, setTelefone] = useState('')
  const [email, setEmail] = useState('')
  const [site, setSite] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!open) return
    api.get('/parceiros/options').then((resp) => setIndicadores(resp.data.data ?? [])).catch(() => setIndicadores([]))
  }, [open])

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    setSaving(true)
    setError('')
    try {
      await referralsService.createStaff({ nome, empresa, telefone, email, site: site.trim() || undefined, parceiroId })
      setNome('')
      setEmpresa('')
      setTelefone('')
      setEmail('')
      setSite('')
      setParceiroId('')
      onSaved()
      onClose()
    } catch (err: unknown) {
      setError(getFriendlyError(err, 'Não foi possível registrar o cliente'))
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal open={open} onClose={onClose} title='Registrar cliente indicado' size='md'>
      <form className='space-y-3' onSubmit={submit}>
        <label className='flex flex-col gap-1 text-xs text-[var(--font-color-label)]'>
          Indicador
          <select
            required
            className='rounded-md border border-[var(--glass-border)] bg-transparent px-3 py-2 text-sm text-[var(--font-color-body)]'
            value={parceiroId}
            onChange={(e) => setParceiroId(e.target.value)}
          >
            <option value=''>Selecione pelo nome</option>
            {indicadores.map((item) => (
              <option key={item.id} value={item.id}>
                {item.empresa && item.empresa !== item.nome ? `${item.nome} · ${item.empresa}` : item.nome}
              </option>
            ))}
          </select>
        </label>
        <Input label='Nome do cliente' value={nome} onChange={(e) => setNome(e.target.value)} required />
        <Input label='Empresa do cliente' value={empresa} onChange={(e) => setEmpresa(e.target.value)} required />
        <Input label='Telefone' value={telefone} onChange={(e) => setTelefone(e.target.value)} />
        <Input label='E-mail' type='email' value={email} onChange={(e) => setEmail(e.target.value)} />
        <Input label='Site' value={site} onChange={(e) => setSite(e.target.value)} placeholder='https://loja.com.br' />
        {error && <p className='text-sm text-rose-500'>{error}</p>}
        <div className='flex justify-end gap-2'>
          <Button type='button' variant='ghost' onClick={onClose}>Cancelar</Button>
          <Button type='submit' loading={saving}>Registrar</Button>
        </div>
      </form>
    </Modal>
  )
}
